import { array, string } from '@gogame/schemas';
import {
  METRIC_SPENT_USD,
  METRIC_TOTAL_CPD_D7,
  METRIC_TOTAL_ROAS_D7,
} from '../constants';

export const metricsSchema = array(string()).default([
  METRIC_SPENT_USD,
  METRIC_TOTAL_ROAS_D7,
  METRIC_TOTAL_CPD_D7,
]);
